
<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          {{Option.title}}
        </b-card-title>
        <b-card-sub-title>{{Option.subtitle}}</b-card-sub-title>
      </div>
      <!--/ title and subtitle -->

      <!-- badge -->
      <!-- <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
        <h5 class="font-weight-bolder mb-0 mr-1">
          $ 100,000
        </h5>
        <b-badge variant="light-secondary">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
            class="text-danger mr-25"
          />
          <span class="align-middle">20%</span>
        </b-badge>
      </div> -->
      <!--/ badge -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="line"
        height="400"
        :options="chartOptions"
        :series="series"
        ref="rp"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import { ref, reactive, watch, watchEffect, getCurrentInstance } from '@vue/composition-api'

export default {
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    Option: {
      type: Object,
      default: ()=>{
        return {
          title: 'title',
          subtitle: 'subtitle',
        }
      }
    },
    Data: {
      type: Array,
      default: ()=>[]
    },
    BaseDate: {
      type: Date,
      default: ()=> new Date(new Date().getFullYear(), 1, 1)
    }
  },
  setup(props, ctx) {
    const vue = getCurrentInstance()
    ctx.emit('chartUpdate', ()=>{
      vue.refs.rp?.updateSeries(
        [
          {
            data: props.Data.reduce((acc, cur)=>{acc.push(cur.value); return acc;}, [])
          },
        ]
      )

      vue.refs.rp?.updateOptions({
        xaxis: {
          categories: props.Data.reduce((acc, cur)=>{acc.push(cur.date); return acc;}, [])
        },
      })
    })


    let series = [
      {
        data: props.Data.reduce((acc, cur)=>{acc.push(cur.value); return acc;}, [])
      },
    ]

    let chartOptions = {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 7,
        strokeOpacity: 1,
        strokeColors: ['#9d95f5'],
        colors: ['#b9b3f8'],
      },
      colors: ['#7367f0'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      tooltip: {
        custom(data) {
          let label = null
          if(data.series[data.seriesIndex][data.dataPointIndex])
            label = new Date(new Date(props.BaseDate).setDate(props.BaseDate.getDate() + parseInt(data.series[data.seriesIndex][data.dataPointIndex]))).toJSON().split('T')[0]

          // return `${'<div class="px-1 py-50"><span>'}${
          //   label.series[data.seriesIndex][data.dataPointIndex]
          // }</span></div>`

          return `${'<div class="px-1 py-50"><span>'}${
            label
          }</span></div>`
        },
      },
      xaxis: {
        categories: props.Data.reduce((acc, cur)=>{acc.push(cur.date); return acc;}, [])
      },
      yaxis: {
        // opposite: isRtl,
        labels: {
          show: true,
          formatter: (val) => { 
            // 取搜尋範圍該年的 1 月 1 號
            return new Date(new Date(props.BaseDate).setDate(props.BaseDate.getDate() + parseInt(val))).toJSON().split('T')[0]
          },
        }
      },
      markers: {
        size: 5,
        colors: ['#9d95f5']
      }
    }

    return {
        series,
        chartOptions,
    }
  },
}
</script>
